import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useEffect } from "react";
export const ShouldStoreToSeenContext = createContext(undefined);
export const ShouldStoreToSeenProvider = ({ children, initial = true, }) => {
    const [shouldStoreToSeen, setShouldStoreToSeen] = useState(initial);
    // keep in sync if the upstream initial changes (e.g., error.code appears later)
    useEffect(() => {
        setShouldStoreToSeen(initial);
    }, [initial]);
    return (_jsx(ShouldStoreToSeenContext.Provider, { value: { shouldStoreToSeen, setShouldStoreToSeen }, children: children }));
};
